export default "__VITE_ASSET__1c181745__"